const state = {
  loginAbnormalFlag: false,
  loginAbnormalType: ''
};

// getters
const getters = {};

//actions
const actions = {
  getLoginAbnormalFlag({ commit, dispatch }, data) {
    commit('setLoginAbnormalFlag', data);
    return data;
  }
};

// mutations
const mutations = {
  setLoginAbnormalFlag(state, data) {
    if (data === 6126) {
      state.loginAbnormalFlag = true;
      state.loginAbnormalType = '2';
    } else if (data === 6127) {
      state.loginAbnormalFlag = true;
      state.loginAbnormalType = '1';
    } else {
      state.loginAbnormalFlag = false;
    }
    // console.log(data, state.loginAbnormalType);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/loginAbnormal.js